import * as React from 'react';

/* Rich-text markers in dictionary copy: ‹…› wraps the accent-coloured span
   (.b-acc), [label](https://…) becomes an external link and \n a line break.
   Mirrors the design export's helper. */
export function Highlight({ text }: { text: string }) {
  const lines = text.replace(/\\n/g, '\n').split('\n');
  return (
    <>
      {lines.map((line, li) => (
        <React.Fragment key={li}>
          {li > 0 && <br />}
          {line.split(/‹|›/).map((part, i) =>
            i % 2 ? (
              <span className="b-acc" key={i}>{part}</span>
            ) : (
              <React.Fragment key={i}>{withLinks(part)}</React.Fragment>
            )
          )}
        </React.Fragment>
      ))}
    </>
  );
}

const LINK = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

function withLinks(text: string): React.ReactNode {
  if (!text.includes('](')) return text;
  const out: React.ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(LINK)) {
    out.push(text.slice(last, m.index));
    out.push(
      <a key={m.index} href={m[2]} target="_blank" rel="noopener noreferrer">
        {m[1]}
      </a>
    );
    last = (m.index ?? 0) + m[0].length;
  }
  out.push(text.slice(last));
  return out;
}
